//Universal code
import './common';

if (!__IS_HWC__) {
  require('./web');
} else {
  require('./sso');
}
